// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../../common/container/Container'
import Header from '../../header/Header'
import { i18n } from '../../index'
import VitrineProductProducts from './VitrineProductProducts'
import VitrineProductWeights from './VitrineProductWeights'
import WastePercentage from './WastePercentage'
import css from './checklistRoot.css'
type Props = {
  history: any
  location: any
  match: any
}

class VitrineProductRoot extends React.Component<Props> {
  getTabs = () => [
    {
      label: i18n.t('admin.navigation.vitrineProducts.products'),
      value: 'tuotteet',
    },
    {
      label: i18n.t('admin.navigation.vitrineProducts.weights'),
      value: 'painoarvot',
    },
    {
      label: i18n.t('admin.navigation.vitrineProducts.wastePercentage'),
      value: 'havikkiprosentti',
    },
  ]
  getActiveTab = () => {
    const parts = this.props.location.pathname.split('/')
    return parts[parts.length - 1] || 'tuotteet'
  }
  onTabClick = (tab) => {
    this.props.history.push(tab.value)
  }

  render() {
    const { match } = this.props
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('admin.header')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('admin.header')}</Typography>
          <Switch>
            <Route path={`${match.path}/tuotteet`} component={VitrineProductProducts} />
            <Route path={`${match.path}/painoarvot`} component={VitrineProductWeights} />
            <Route path={`${match.path}/havikkiprosentti`} component={WastePercentage} />
            <Redirect to={`${match.path}/tuotteet`} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(VitrineProductRoot)
